import { connect } from 'react-redux';

import { AppState } from '../../../store/store';

import { Page as Presentation } from './page.component';

export const Page = connect(
  (state: AppState) => ({
    selectedPage: state.pages.selected,
    open: state.layout.navbar,
  }),
)(Presentation);
